import React from "react";
import Layout from "../Components/Layout";
import { Container, Row, Col, FormControl } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import LayoutCoach from "../Components/LayoutCoach";
import { useSelector } from "react-redux";
import {
  changeAutoApprove,
  coachLogin,
  editcoachProfile,
  getUserProfile,
} from "../Redux/Actions/coachAction";
import { useMutation, useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
export default function SettingsCoach() {
  const navigate = useNavigate();

  // // ======================================check for language=======================================

  const ingerman = useSelector((state) => state.homedata.selectedLang);
  console.log(ingerman);

  // ================================================get user data from redux===========================================

  const userData = useSelector((state) => state?.registerUserdata?.user);
  console.log(userData);

  // ========================================fetch data by usequery===============================

  const { data, isSuccess, isError, refetch } = useQuery({
    queryKey: ["coachdetailscoachSide"],
    queryFn: getUserProfile,
  });

  {
    // isSuccess && dispatch(coachDetails(data));
  }

  {
    isError && toast.error(data?.message || "Something went wrong");
  }

  console.log(data, "data");

  // ===========================================POST DATA USING REACT QUERY==========================

  const { isPending, mutate } = useMutation({
    mutationFn: changeAutoApprove,
    onSuccess: (res) => {
      if (res?.success) {
        toast.success(res?.message);
        refetch();
        // res?.data?.role== 0 ?  navigate("/get-started") : ""
        //  sessionStorage.clear()
        // navigate("/your-password-reset");
      } else {
        toast.error(res?.message);
      }
    },
    onError: (res) => {
      toast.error(res?.message);
    },
  });

  // ===========================================POST DATA USING REACT QUERY==========================

  const { isPending: minpending, mutate: minmutate } = useMutation({
    mutationFn: editcoachProfile,
    onSuccess: (res) => {
      if (res?.success) {
        // toast.success(res?.message);
        refetch();
        // res?.data?.role== 0 ?  navigate("/get-started") : ""
        //  sessionStorage.clear()
        // navigate("/your-password-reset");
      } else {
        toast.error(res?.message);
      }
    },
    onError: (res) => {
      toast.error(res?.message);
    },
  });

  return (
    <LayoutCoach>
      <div style={{ position: "relative" }} className="right-side">
        {(isPending || minpending) && (
          <div
            style={{
              position: "absolute",
              width: "110%",
              height: "100%",
              zIndex: "1",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              // backgroundColor: "rgba(0,0,0,0.1)",
            }}
          >
            <div class="loader"></div>
          </div>
        )}
        <div className="main-content">
          <h2>{ingerman == "de" ? "Einstellungen" : "Settings"}</h2>
          <div className="setting-list-box">
            <ul>
              {userData?.login_type == 2 ? (
                ""
              ) : (
                <li>
                  <Link to="/change-password" className="setting-list-item">
                    <div className="icon-txt">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="63"
                          height="63"
                          viewBox="0 0 63 63"
                          fill="none"
                        >
                          <rect
                            width="62.7451"
                            height="62.7451"
                            rx="31.3725"
                            fill="#4CA890"
                            fill-opacity="0.2"
                          />
                          <path
                            d="M32.2072 28.7639C31.1484 25.7182 28.3056 23.5352 24.9559 23.5352C20.7014 23.5352 17.2554 27.045 17.2554 31.3783C17.2554 35.7116 20.7014 39.2214 24.9559 39.2214C28.3056 39.2214 31.1484 37.0384 32.2072 33.9927H37.7901V39.2214H42.9238V33.9927H45.4907V28.7639H32.2072ZM24.9559 33.9927C23.5377 33.9927 22.3891 32.8227 22.3891 31.3783C22.3891 29.9338 23.5377 28.7639 24.9559 28.7639C26.3741 28.7639 27.5227 29.9338 27.5227 31.3783C27.5227 32.8227 26.3741 33.9927 24.9559 33.9927Z"
                            fill="#4CA890"
                          />
                        </svg>
                      </span>
                      <h3>
                        {ingerman == "de"
                          ? "Passwort ändern"
                          : "Change Password"}
                      </h3>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="16"
                      viewBox="0 0 11 16"
                      fill="none"
                    >
                      <path
                        d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                        fill="#585858"
                      />
                    </svg>
                  </Link>
                </li>
              )}

              <li>
                <Link to="/wallet-coach" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="63"
                        height="63"
                        viewBox="0 0 63 63"
                        fill="none"
                      >
                        <rect
                          width="62.75"
                          height="62.75"
                          rx="31.375"
                          fill="#DBEEE9"
                        />
                        <path
                          d="M39.1129 24.8085C38.973 24.8085 38.8597 24.8085 38.7478 24.8085C34.039 24.8085 29.3303 24.8085 24.623 24.8098C24.4831 24.8098 24.3418 24.8112 24.2047 24.8339C23.7864 24.9022 23.494 25.261 23.5192 25.6586C23.5444 26.063 23.8689 26.3816 24.2914 26.411C24.3963 26.4191 24.5013 26.4151 24.6062 26.4151C30.4704 26.4151 36.3333 26.4151 42.1975 26.4177C42.4143 26.4177 42.6396 26.4258 42.848 26.4766C43.5153 26.6413 43.9252 27.1943 43.9252 27.9065C43.9266 31.3232 43.9252 34.7399 43.9252 38.1565C43.9252 39.0616 43.9266 39.9653 43.9252 40.8703C43.9224 41.7513 43.3278 42.331 42.4059 42.3564C42.3528 42.3578 42.301 42.3564 42.2479 42.3564C35.5261 42.3564 28.8057 42.3564 22.0839 42.3538C21.8839 42.3538 21.6782 42.3471 21.4852 42.3002C20.8347 42.1436 20.3996 41.592 20.3968 40.9279C20.3926 39.5382 20.3954 38.1472 20.3954 36.7575C20.3954 32.9646 20.3954 29.1704 20.3954 25.3775C20.3954 24.4483 20.7997 23.9784 21.744 23.7762C25.2749 23.0198 28.8029 22.2594 32.3324 21.5002C33.9859 21.1441 35.6394 20.7826 37.2943 20.4332C38.2134 20.2391 39.0597 20.7947 39.1017 21.6796C39.1507 22.7092 39.1129 23.7388 39.1129 24.8085ZM39.8152 35.8176C40.5985 35.8163 41.2378 35.2085 41.2406 34.4627C41.2434 33.713 40.5818 33.0837 39.7984 33.0931C39.0164 33.1025 38.3897 33.7157 38.3939 34.4667C38.3967 35.2192 39.0276 35.819 39.8152 35.8176Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>Wallet</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M19.1279 31.7869C19.1279 38.7127 24.7499 44.3359 31.6769 44.3359C38.6166 44.3359 44.226 38.7127 44.226 31.7869C44.226 24.8586 38.6166 19.2379 31.6769 19.2379C24.7499 19.2379 19.1279 24.8586 19.1279 31.7869ZM30.5726 36.543C30.5726 37.1441 31.0746 37.6473 31.6769 37.6473C32.2793 37.6473 32.7687 37.1441 32.7687 36.543V30.9963C32.7687 30.3927 32.2793 29.9046 31.6769 29.9046C31.0746 29.9046 30.5726 30.3927 30.5726 30.9963V36.543ZM31.6895 25.9127C31.0746 25.9127 30.5852 26.4147 30.5852 27.017C30.5852 27.6194 31.0746 28.1088 31.6769 28.1088C32.2918 28.1088 32.7813 27.6194 32.7813 27.017C32.7813 26.4147 32.2918 25.9127 31.6895 25.9127Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>FAQs</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to="/reviews-coach" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="63"
                        height="64"
                        viewBox="0 0 63 64"
                        fill="none"
                      >
                        <rect
                          y="0.625"
                          width="62.75"
                          height="62.75"
                          rx="31.375"
                          fill="#DBEEE9"
                        />
                        <path
                          d="M31.3742 17.8809L35.2522 25.6256L43.9242 26.8752L37.6492 32.9003L39.1301 41.4121L31.3742 37.3913L23.6183 41.4121L25.0992 32.9003L18.8242 26.8752L27.4963 25.6256L31.3742 17.8809Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman == "de" ? "Rezensionen" : "Reviews"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to="/change-language" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M26.8579 41.6492H25.744C25.5641 41.6489 25.3915 41.5773 25.2642 41.4501C25.137 41.3228 25.0654 41.1502 25.0651 40.9703V37.0552C25.0651 36.8558 25.006 36.6608 24.8953 36.495C24.7845 36.3292 24.627 36.1999 24.4427 36.1236C24.2585 36.0473 24.0557 36.0273 23.8601 36.0663C23.6646 36.1052 23.4849 36.2013 23.3439 36.3423L20.9657 38.7206C20.8721 38.8142 20.7978 38.9253 20.7472 39.0476C20.6965 39.17 20.6704 39.3011 20.6704 39.4334C20.6704 39.5658 20.6965 39.6969 20.7472 39.8193C20.7978 39.9416 20.8721 40.0527 20.9657 40.1463C21.1548 40.3354 21.4112 40.4416 21.6786 40.4416C21.811 40.4416 21.9421 40.4155 22.0644 40.3649C22.1867 40.3142 22.2978 40.2399 22.3914 40.1463L23.0485 39.4898V40.9703C23.0493 41.6849 23.3335 42.3701 23.8389 42.8755C24.3442 43.3808 25.0294 43.665 25.7441 43.6658H26.8579C27.1254 43.6658 27.3818 43.5596 27.5709 43.3705C27.76 43.1814 27.8662 42.9249 27.8662 42.6575C27.8662 42.3901 27.76 42.1336 27.5709 41.9445C27.3818 41.7554 27.1254 41.6492 26.8579 41.6492Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M36.9414 23.4971H38.0575C38.2369 23.4973 38.4089 23.5687 38.5358 23.6955C38.6627 23.8224 38.734 23.9944 38.7342 24.1738V28.0911C38.7342 28.2905 38.7933 28.4854 38.9041 28.6513C39.0149 28.8171 39.1724 28.9463 39.3566 29.0226C39.5409 29.0989 39.7436 29.1189 39.9392 29.08C40.1348 29.041 40.3144 28.945 40.4554 28.8039L42.8337 26.4257C42.9273 26.3321 43.0015 26.2209 43.0522 26.0986C43.1029 25.9763 43.1289 25.8452 43.1289 25.7128C43.1289 25.5804 43.1029 25.4493 43.0522 25.327C43.0015 25.2047 42.9273 25.0936 42.8337 24.9999C42.74 24.9063 42.6289 24.8321 42.5066 24.7814C42.3843 24.7307 42.2532 24.7047 42.1208 24.7047C41.9884 24.7047 41.8573 24.7307 41.735 24.7814C41.6127 24.8321 41.5015 24.9063 41.4079 24.9999L40.7508 25.6565V24.1738C40.7501 23.4597 40.4661 22.7751 39.9612 22.2701C39.4562 21.7652 38.7716 21.4812 38.0575 21.4805H36.9414C36.674 21.4805 36.4175 21.5867 36.2284 21.7758C36.0393 21.9649 35.9331 22.2214 35.9331 22.4888C35.9331 22.7562 36.0393 23.0127 36.2284 23.2017C36.4175 23.3908 36.674 23.4971 36.9414 23.4971Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M36.9463 38.587C37.2769 38.2435 37.5883 37.8819 37.8789 37.5039H36.0127C36.304 37.8816 36.6157 38.2432 36.9463 38.587Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M43.6658 30.4429H34.59V20.2466C34.59 20.1142 34.564 19.983 34.5133 19.8607C34.4626 19.7384 34.3884 19.6272 34.2947 19.5336C34.2011 19.4399 34.0899 19.3657 33.9676 19.315C33.8453 19.2643 33.7141 19.2383 33.5817 19.2383H20.1362C20.0038 19.2383 19.8727 19.2643 19.7504 19.315C19.628 19.3657 19.5169 19.4399 19.4232 19.5336C19.3296 19.6272 19.2553 19.7384 19.2047 19.8607C19.154 19.983 19.1279 20.1142 19.1279 20.2466V33.6921C19.1279 33.8245 19.154 33.9556 19.2047 34.0779C19.2553 34.2003 19.3296 34.3114 19.4232 34.4051C19.5169 34.4987 19.628 34.573 19.7504 34.6236C19.8727 34.6743 20.0038 34.7004 20.1362 34.7004H29.212V44.8966C29.212 45.0291 29.2381 45.1602 29.2888 45.2825C29.3394 45.4049 29.4137 45.516 29.5073 45.6096C29.601 45.7033 29.7121 45.7776 29.8345 45.8282C29.9568 45.8789 30.0879 45.905 30.2203 45.9049H43.6658C43.7983 45.905 43.9294 45.8789 44.0517 45.8282C44.174 45.7776 44.2852 45.7033 44.3788 45.6096C44.4725 45.516 44.5467 45.4049 44.5974 45.2825C44.6481 45.1602 44.6742 45.0291 44.6741 44.8966V31.4512C44.6742 31.3187 44.6481 31.1876 44.5974 31.0653C44.5467 30.9429 44.4725 30.8318 44.3788 30.7382C44.2852 30.6445 44.174 30.5703 44.0517 30.5196C43.9294 30.4689 43.7983 30.4428 43.6658 30.4429ZM30.5623 29.3197L27.7611 23.7174C27.4187 23.0335 26.2993 23.0335 25.9568 23.7174L23.1557 29.3197C23.0361 29.5589 23.0165 29.8359 23.1011 30.0896C23.1858 30.3434 23.3678 30.5531 23.607 30.6726C23.8463 30.7922 24.1233 30.8118 24.377 30.7272C24.6307 30.6425 24.8404 30.4605 24.96 30.2213L25.2414 29.6583H28.4766L28.758 30.2213C28.8296 30.3625 28.9338 30.4847 29.0619 30.5778C29.1901 30.6708 29.3385 30.7321 29.495 30.7565C29.3143 30.9427 29.2128 31.1917 29.212 31.4512V32.6838H21.1445V21.2549H32.5734V30.4429H30.4051C30.5415 30.2933 30.6295 30.106 30.6575 29.9056C30.6856 29.7051 30.6524 29.5009 30.5623 29.3197ZM27.4684 27.6417H26.2496L26.859 26.4228L27.4684 27.6417ZM40.8647 37.5015H40.3285C39.7931 38.3694 39.1687 39.1791 38.4655 39.9176C39.1461 40.4243 39.889 40.8413 40.6759 41.1583C40.7994 41.2068 40.912 41.2792 41.0074 41.3714C41.1029 41.4635 41.1791 41.5736 41.232 41.6952C41.2848 41.8169 41.313 41.9478 41.3152 42.0804C41.3173 42.213 41.2932 42.3448 41.2443 42.4681C41.1955 42.5914 41.1227 42.7038 41.0303 42.7989C40.9379 42.8941 40.8277 42.9701 40.7058 43.0225C40.584 43.075 40.453 43.1029 40.3204 43.1046C40.1878 43.1064 40.0561 43.0819 39.933 43.0327C38.8587 42.6019 37.8518 42.0192 36.9431 41.3022C36.0344 42.0192 35.0275 42.6019 33.9532 43.0327C33.8352 43.08 33.7093 43.1043 33.5823 43.1044C33.3476 43.1044 33.1203 43.0225 32.9395 42.873C32.7587 42.7235 32.6357 42.5156 32.5916 42.2851C32.5476 42.0547 32.5852 41.8161 32.6981 41.6104C32.8111 41.4047 32.9922 41.2448 33.2102 41.1583C33.9976 40.8416 34.7411 40.4253 35.4226 39.9197C34.7186 39.1806 34.0936 38.3702 33.5576 37.5015H33.0215C32.7541 37.5015 32.4976 37.3953 32.3085 37.2062C32.1194 37.0171 32.0132 36.7606 32.0132 36.4932C32.0132 36.2258 32.1194 35.9693 32.3085 35.7802C32.4976 35.5911 32.7541 35.4849 33.0215 35.4849H35.9348V34.2523C35.9348 33.9849 36.041 33.7284 36.2301 33.5393C36.4192 33.3502 36.6757 33.244 36.9431 33.244C37.2105 33.244 37.467 33.3502 37.6561 33.5393C37.8452 33.7284 37.9514 33.9849 37.9514 34.2523V35.4849H40.8647C41.1321 35.4849 41.3886 35.5911 41.5777 35.7802C41.7668 35.9693 41.873 36.2258 41.873 36.4932C41.873 36.7606 41.7668 37.0171 41.5777 37.2062C41.3886 37.3953 41.1321 37.5015 40.8647 37.5015Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman == "de" ? "Sprache" : "Language"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <div>
                  <Link to="/invoice-price" className="setting-list-item">
                    <div className="icon-txt">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="64"
                          height="64"
                          viewBox="0 0 64 64"
                          fill="none"
                        >
                          <rect
                            x="0.304199"
                            y="0.414062"
                            width="62.7451"
                            height="62.7451"
                            rx="31.3725"
                            fill="#4CA890"
                            fill-opacity="0.2"
                          />
                          <path
                            d="M37.6164 20.8047H26.5901C25.859 20.8047 25.1578 21.0951 24.6409 21.6121C24.1239 22.129 23.8335 22.8302 23.8335 23.5613V42.7655L27.2057 40.4591L29.66 42.137L32.1097 40.4591L34.5594 42.137L37.0072 40.4601L40.373 42.7655V23.5613C40.373 22.8302 40.0826 22.129 39.5656 21.6121C39.0487 21.0951 38.3475 20.8047 37.6164 20.8047ZM34.8598 33.6687H27.5089V31.831H34.8598V33.6687ZM36.6976 29.0744H27.5089V27.2367H36.6976V29.0744Z"
                            fill="#4CA890"
                          />
                        </svg>
                      </span>
                      <h3>{ingerman == "de" ? "Rechnungen" : "Invoice"}</h3>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="16"
                      viewBox="0 0 11 16"
                      fill="none"
                    >
                      <path
                        d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                        fill="#585858"
                      />
                    </svg>
                  </Link>
                </div>
              </li>
              <li>
                <div>
                  <Link to="/access-agreement" className="setting-list-item">
                    <div className="icon-txt">
                      <span>
                        <svg
                          width="64"
                          height="64"
                          viewBox="0 0 64 64"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.300781"
                            y="0.414062"
                            width="62.7451"
                            height="62.7451"
                            rx="31.3725"
                            fill="#4CA890"
                            fill-opacity="0.2"
                          />
                          <g clip-path="url(#clip0_4512_304)">
                            <path
                              d="M33.1325 39.2225C33.1325 37.5959 33.7658 36.0664 34.9161 34.9161C36.0664 33.7658 37.5955 33.1325 39.2225 33.1325C40.558 33.1325 41.8278 33.56 42.8764 34.3494C42.9345 33.5 42.9706 32.5498 42.972 31.4862C42.9692 28.8111 42.7447 26.8522 42.5052 25.4127C42.0861 23.0408 39.9317 20.8864 37.5598 20.4673C36.1203 20.2273 34.1614 20.0028 31.4858 20C28.8106 20.0028 26.8512 20.2273 25.4117 20.4669C23.0403 20.8859 20.8859 23.0403 20.4669 25.4122C20.2273 26.8517 20.0033 28.8106 20 31.4858C20.0033 34.1609 20.2273 36.1203 20.4669 37.5598C20.8859 39.9317 23.0403 42.0861 25.4122 42.5052C26.8517 42.7447 28.8106 42.9687 31.4862 42.972C32.5498 42.9706 33.5 42.9345 34.3494 42.8764C33.56 41.8278 33.1325 40.5584 33.1325 39.2225ZM25.8106 25.5509H37.1614C37.8955 25.5509 38.4908 26.1462 38.4908 26.8803C38.4908 27.6144 37.8955 28.2097 37.1614 28.2097H25.8106C25.0766 28.2097 24.4812 27.6144 24.4812 26.8803C24.4812 26.1462 25.0766 25.5509 25.8106 25.5509ZM25.8106 33.7611C25.0766 33.7611 24.4812 33.1658 24.4812 32.4317C24.4812 31.6977 25.0766 31.1023 25.8106 31.1023H32.4739C33.208 31.1023 33.8033 31.6977 33.8033 32.4317C33.8033 33.1658 33.208 33.7611 32.4739 33.7611H25.8106Z"
                              fill="#4CA890"
                            />
                            <path
                              d="M39.2228 34.4453C36.5842 34.4453 34.4453 36.5842 34.4453 39.2228C34.4453 41.8614 36.5842 44.0003 39.2228 44.0003C41.8614 44.0003 44.0003 41.8614 44.0003 39.2228C44.0003 36.5842 41.8614 34.4453 39.2228 34.4453ZM40.1134 41.5933C40.1134 42.085 39.7145 42.4839 39.2228 42.4839C38.7311 42.4839 38.3322 42.085 38.3322 41.5933V39.2434C38.3322 38.7517 38.7311 38.3528 39.2228 38.3528C39.7145 38.3528 40.1134 38.7517 40.1134 39.2434V41.5933ZM40.0769 37.337C40.0441 37.5227 39.8753 37.6914 39.6897 37.7242C39.5772 37.743 39.4234 37.7603 39.2139 37.7608C39.0044 37.7608 38.8511 37.743 38.7381 37.7242C38.5525 37.6914 38.3838 37.5227 38.3509 37.337C38.3322 37.2245 38.3148 37.0708 38.3144 36.8613C38.3144 36.6517 38.3322 36.4984 38.3509 36.3855C38.3838 36.1998 38.5525 36.0311 38.7381 35.9983C38.8506 35.9795 39.0044 35.9622 39.2139 35.9617C39.4234 35.9617 39.5767 35.9795 39.6897 35.9983C39.8753 36.0311 40.0441 36.1998 40.0769 36.3855C40.0956 36.498 40.113 36.6517 40.1134 36.8613C40.1134 37.0708 40.0956 37.2241 40.0769 37.337Z"
                              fill="#4CA890"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_4512_304">
                              <rect
                                width="24"
                                height="24"
                                fill="white"
                                transform="translate(20 20)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <h3>
                        {ingerman == "de"
                          ? "Zugangsvereinbarung"
                          : "Access Agreement"}
                      </h3>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="16"
                      viewBox="0 0 11 16"
                      fill="none"
                    >
                      <path
                        d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                        fill="#585858"
                      />
                    </svg>
                  </Link>
                </div>
              </li>
              <li>
                <div>
                  <Link to="/data-protection" className="setting-list-item">
                    <div className="icon-txt">
                      <span>
                        <svg
                          width="63"
                          height="63"
                          viewBox="0 0 63 63"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="62.7451"
                            height="62.7451"
                            rx="31.3725"
                            fill="#4CA890"
                            fill-opacity="0.2"
                          />
                          <path
                            d="M28.1 25.1867C32.2974 25.1867 35.7 24.1122 35.7 22.7867C35.7 21.4612 32.2974 20.3867 28.1 20.3867C23.9026 20.3867 20.5 21.4612 20.5 22.7867C20.5 24.1122 23.9026 25.1867 28.1 25.1867Z"
                            fill="#4CA890"
                          />
                          <path
                            d="M20.5 32.3873C20.5 33.5225 23.62 34.7873 28.1 34.7873C29.5827 34.7991 31.0617 34.6392 32.5076 34.3109C32.5273 33.7951 32.7457 33.307 33.117 32.9485C33.4883 32.59 33.9839 32.3889 34.5 32.3873V29.7037C32.9376 30.3873 30.6124 30.7873 28.1 30.7873C25.0872 30.7873 21.9364 30.1729 20.5 29.0117V32.3873Z"
                            fill="#4CA890"
                          />
                          <path
                            d="M20.5 27.5865C20.5 28.7217 23.62 29.9865 28.1 29.9865C30.6744 29.9865 33.1036 29.5361 34.5248 28.8045C34.6251 27.9739 35.047 27.2156 35.7 26.6925V24.2125C34.2636 25.3721 31.1128 25.9865 28.1 25.9865C25.0872 25.9865 21.9364 25.3721 20.5 24.2109V27.5865ZM23.3104 27.4345C23.322 27.3833 23.3437 27.3348 23.3742 27.2919C23.4047 27.2491 23.4434 27.2127 23.488 27.1849C23.5327 27.1572 23.5824 27.1385 23.6343 27.1301C23.6862 27.1216 23.7393 27.1235 23.7904 27.1357C23.9172 27.1649 24.0464 27.1933 24.1784 27.2197C24.2756 27.2395 24.362 27.2946 24.4209 27.3745C24.4797 27.4544 24.5067 27.5532 24.4968 27.6519C24.4868 27.7506 24.4405 27.8421 24.3669 27.9086C24.2933 27.9751 24.1976 28.0118 24.0984 28.0117C24.0715 28.012 24.0447 28.0095 24.0184 28.0041C23.8784 27.9761 23.7411 27.9463 23.6064 27.9145C23.5037 27.8898 23.4149 27.8255 23.3594 27.7356C23.304 27.6456 23.2863 27.5374 23.3104 27.4345ZM21.3376 26.6969C21.3599 26.6493 21.3913 26.6066 21.4301 26.5711C21.4689 26.5357 21.5142 26.5082 21.5637 26.4903C21.6131 26.4724 21.6655 26.4644 21.718 26.4668C21.7705 26.4692 21.822 26.4818 21.8696 26.5041C21.9896 26.5604 22.1153 26.6145 22.2468 26.6665C22.2967 26.6851 22.3424 26.7134 22.3812 26.7498C22.42 26.7862 22.4512 26.8299 22.4728 26.8785C22.4945 26.9271 22.5063 26.9796 22.5074 27.0328C22.5086 27.086 22.4992 27.1388 22.4796 27.1883C22.4601 27.2378 22.4309 27.2829 22.3937 27.321C22.3565 27.3591 22.3121 27.3893 22.2631 27.41C22.2141 27.4307 22.1614 27.4414 22.1082 27.4415C22.055 27.4416 22.0023 27.4311 21.9532 27.4105C21.806 27.3521 21.6644 27.2905 21.5304 27.2289C21.4828 27.2067 21.44 27.1753 21.4046 27.1365C21.3691 27.0977 21.3417 27.0523 21.3238 27.0029C21.3059 26.9535 21.2979 26.901 21.3002 26.8485C21.3026 26.796 21.3153 26.7445 21.3376 26.6969ZM35.3 32.3865H36.1V29.1865C36.1 28.7622 36.2686 28.3552 36.5686 28.0552C36.8687 27.7551 37.2757 27.5865 37.7 27.5865H38.5C38.9243 27.5865 39.3313 27.7551 39.6314 28.0552C39.9314 28.3552 40.1 28.7622 40.1 29.1865V32.3865H40.9V29.1865C40.8994 28.5502 40.6463 27.9401 40.1964 27.4902C39.7464 27.0402 39.1363 26.7872 38.5 26.7865H37.7C37.0637 26.7872 36.4536 27.0402 36.0036 27.4902C35.5537 27.9401 35.3006 28.5502 35.3 29.1865V32.3865ZM38.1 35.9865C37.8365 35.9873 37.5806 36.0748 37.3717 36.2355C37.1629 36.3962 37.0127 36.6212 36.9445 36.8757C36.8762 37.1302 36.8936 37.4001 36.994 37.6438C37.0944 37.8874 37.2722 38.0912 37.5 38.2237C37.5609 38.2589 37.6114 38.3094 37.6465 38.3703C37.6816 38.4312 37.7001 38.5003 37.7 38.5705V39.5865H38.5V38.5705C38.4999 38.5003 38.5184 38.4312 38.5535 38.3703C38.5886 38.3094 38.6391 38.2589 38.7 38.2237C38.9278 38.0912 39.1056 37.8874 39.206 37.6438C39.3064 37.4001 39.3238 37.1302 39.2555 36.8757C39.1873 36.6212 39.0371 36.3962 38.8283 36.2355C38.6195 36.0748 38.3635 35.9873 38.1 35.9865ZM28.1 39.5865C29.5801 39.5986 31.0566 39.4393 32.5 39.1117V35.1349C31.0541 35.4451 29.5787 35.5966 28.1 35.5865C25.0872 35.5865 21.9364 34.9721 20.5 33.8109V37.1865C20.5 38.3217 23.62 39.5865 28.1 39.5865Z"
                            fill="#4CA890"
                          />
                          <path
                            d="M42.9008 34.3875C42.9008 34.0692 42.7744 33.764 42.5493 33.539C42.3243 33.3139 42.019 33.1875 41.7008 33.1875H34.5008C34.1825 33.1875 33.8773 33.3139 33.6523 33.539C33.4272 33.764 33.3008 34.0692 33.3008 34.3875V41.5875C33.3008 41.9058 33.4272 42.211 33.6523 42.436C33.8773 42.6611 34.1825 42.7875 34.5008 42.7875H41.7008C42.019 42.7875 42.3243 42.6611 42.5493 42.436C42.7744 42.211 42.9008 41.9058 42.9008 41.5875V34.3875ZM39.3008 38.7875V39.5875C39.3008 39.7997 39.2165 40.0032 39.0665 40.1532C38.9164 40.3032 38.713 40.3875 38.5008 40.3875H37.7008C37.4886 40.3875 37.2851 40.3032 37.1351 40.1532C36.9851 40.0032 36.9008 39.7997 36.9008 39.5875V38.7875C36.565 38.5356 36.3169 38.1845 36.1918 37.7838C36.0666 37.3832 36.0707 36.9533 36.2034 36.555C36.3362 36.1568 36.5908 35.8105 36.9314 35.565C37.2719 35.3196 37.681 35.1875 38.1008 35.1875C38.5205 35.1875 38.9297 35.3196 39.2702 35.565C39.6107 35.8105 39.8654 36.1568 39.9981 36.555C40.1309 36.9533 40.135 37.3832 40.0098 37.7838C39.8846 38.1845 39.6366 38.5356 39.3008 38.7875Z"
                            fill="#4CA890"
                          />
                        </svg>
                      </span>
                      <h3>
                        {ingerman == "de" ? "Datenschutz" : "Data Protection"}
                      </h3>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="16"
                      viewBox="0 0 11 16"
                      fill="none"
                    >
                      <path
                        d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                        fill="#585858"
                      />
                    </svg>
                  </Link>
                </div>
              </li>
              <li>
                <div className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="63"
                        height="63"
                        viewBox="0 0 63 63"
                        fill="none"
                      >
                        <rect
                          width="62.75"
                          height="62.75"
                          rx="31.375"
                          fill="#DBEEE9"
                        />
                        <path
                          d="M42.1873 29.4955C41.2702 25.0567 38.6502 22.1045 34.3052 20.8288C29.9329 19.5457 25.3098 21.1735 22.5798 24.8186C20.9441 27.0012 20.2264 29.4732 20.4276 32.1931C20.7901 37.0932 24.3024 41.0979 29.125 42.1231C29.577 42.2198 30.0422 42.2545 30.5016 42.3198C30.5645 42.3281 30.6258 42.3438 30.6879 42.357H32.0603C32.4626 42.3016 32.8674 42.2611 33.2664 42.19C35.8217 41.7362 37.9599 40.5299 39.6626 38.578C41.2462 36.7617 42.1286 34.6411 42.3214 32.2378C42.3256 32.1816 42.3446 32.127 42.357 32.0716V30.7009C42.3016 30.2991 42.2693 29.8923 42.1873 29.4955ZM38.4971 27.971C38.4938 28.0115 38.4888 28.052 38.4822 28.0909C38.4781 28.1181 38.4723 28.1446 38.4665 28.1702C38.4383 28.3017 38.3911 28.4249 38.3299 28.5423C38.3084 28.5836 38.2844 28.6241 38.2579 28.6638C38.2554 28.6696 38.2521 28.6745 38.2479 28.6803C38.219 28.725 38.1875 28.7688 38.1536 28.8118C38.1023 28.8763 38.0468 28.9391 37.9864 29.0003C36.085 30.9282 34.1869 32.8578 32.2888 34.7883C31.908 35.1752 31.533 35.5687 31.1514 35.9548C30.4445 36.6707 29.4404 36.6848 28.7277 35.9763C27.3892 34.6477 26.0531 33.3167 24.7254 31.9773C23.8496 31.0927 24.2196 29.6633 25.3984 29.3541C25.9869 29.1995 26.4993 29.3616 26.9281 29.7881C27.7079 30.5645 28.4851 31.3432 29.2641 32.1204C29.6945 32.5503 30.115 32.547 30.5463 32.1096C32.2929 30.3404 34.037 28.5695 35.7853 26.802C36.5212 26.0587 37.6288 26.1158 38.2115 26.9194C38.3473 27.1079 38.4375 27.3121 38.4772 27.532C38.4797 27.5444 38.4822 27.556 38.4839 27.5684C38.4872 27.5865 38.4897 27.6056 38.4913 27.6237C38.4954 27.6535 38.4979 27.6833 38.4996 27.713C38.5004 27.7155 38.5004 27.718 38.4996 27.7213C38.5021 27.7535 38.5037 27.7866 38.5029 27.8205C38.5037 27.8718 38.5021 27.9214 38.4971 27.971Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>
                      {ingerman == "de"
                        ? "Automatische Genehmigung"
                        : "Auto-Approval"}
                    </h3>
                  </div>

                  <div style={{ cursor: "pointer" }}>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      onChange={(e) => {
                        console.log(e.target.checked);
                        mutate({
                          status: e.target.checked == true ? 1 : 0,
                        });
                      }}
                      checked={data?.data?.auto_approve == 1 ? true : false}
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="63"
                        height="63"
                        viewBox="0 0 63 63"
                        fill="none"
                      >
                        <rect
                          width="62.75"
                          height="62.75"
                          rx="31.375"
                          fill="#DBEEE9"
                        />
                        <path
                          d="M42.1873 29.4955C41.2702 25.0567 38.6502 22.1045 34.3052 20.8288C29.9329 19.5457 25.3098 21.1735 22.5798 24.8186C20.9441 27.0012 20.2264 29.4732 20.4276 32.1931C20.7901 37.0932 24.3024 41.0979 29.125 42.1231C29.577 42.2198 30.0422 42.2545 30.5016 42.3198C30.5645 42.3281 30.6258 42.3438 30.6879 42.357H32.0603C32.4626 42.3016 32.8674 42.2611 33.2664 42.19C35.8217 41.7362 37.9599 40.5299 39.6626 38.578C41.2462 36.7617 42.1286 34.6411 42.3214 32.2378C42.3256 32.1816 42.3446 32.127 42.357 32.0716V30.7009C42.3016 30.2991 42.2693 29.8923 42.1873 29.4955ZM38.4971 27.971C38.4938 28.0115 38.4888 28.052 38.4822 28.0909C38.4781 28.1181 38.4723 28.1446 38.4665 28.1702C38.4383 28.3017 38.3911 28.4249 38.3299 28.5423C38.3084 28.5836 38.2844 28.6241 38.2579 28.6638C38.2554 28.6696 38.2521 28.6745 38.2479 28.6803C38.219 28.725 38.1875 28.7688 38.1536 28.8118C38.1023 28.8763 38.0468 28.9391 37.9864 29.0003C36.085 30.9282 34.1869 32.8578 32.2888 34.7883C31.908 35.1752 31.533 35.5687 31.1514 35.9548C30.4445 36.6707 29.4404 36.6848 28.7277 35.9763C27.3892 34.6477 26.0531 33.3167 24.7254 31.9773C23.8496 31.0927 24.2196 29.6633 25.3984 29.3541C25.9869 29.1995 26.4993 29.3616 26.9281 29.7881C27.7079 30.5645 28.4851 31.3432 29.2641 32.1204C29.6945 32.5503 30.115 32.547 30.5463 32.1096C32.2929 30.3404 34.037 28.5695 35.7853 26.802C36.5212 26.0587 37.6288 26.1158 38.2115 26.9194C38.3473 27.1079 38.4375 27.3121 38.4772 27.532C38.4797 27.5444 38.4822 27.556 38.4839 27.5684C38.4872 27.5865 38.4897 27.6056 38.4913 27.6237C38.4954 27.6535 38.4979 27.6833 38.4996 27.713C38.5004 27.7155 38.5004 27.718 38.4996 27.7213C38.5021 27.7535 38.5037 27.7866 38.5029 27.8205C38.5037 27.8718 38.5021 27.9214 38.4971 27.971Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>
                      {ingerman == "de"
                        ? "30-minütiger kostenloser Termin"
                        : "30 Min Free Appointment"}
                    </h3>
                  </div>
                  <Form>
                    <Form.Check // prettier-ignore
                      type="switch"
                      id="custom-switch"
                      onChange={(e) => {
                        console.log(e.target.checked);
                        let formdata = new FormData();
                        formdata?.append(
                          "free_30_minutes",
                          e.target.checked == true ? 1 : 0
                        );
                        minmutate(formdata);
                      }}
                      checked={data?.data?.free_30_minutes == 1 ? true : false}
                    />
                  </Form>
                </div>
              </li>
              <li>
                <Link to="/imprint" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.300781"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M33.4752 38.8438L32.5045 40.6623C32.4354 40.7927 32.2953 40.875 32.143 40.875C31.9907 40.875 31.8516 40.7927 31.7815 40.6623L30.8128 38.8447C25.1232 39.0153 22.2617 40.179 22.2617 40.7966C22.2617 41.4848 25.6554 42.768 32.144 42.768C38.6326 42.768 42.0262 41.4848 42.0262 40.7966C42.0262 40.179 39.1647 39.0163 33.4744 38.8447L33.4752 38.8438Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M30.0307 36.1303C30.183 36.1303 30.3221 36.2127 30.3922 36.3431L31.4178 38.2675C31.4208 38.2733 31.4239 38.2773 31.4259 38.2831L32.1408 39.6232L32.8577 38.2802C32.8597 38.2763 32.8617 38.2723 32.8637 38.2674L33.8914 36.3421C33.9604 36.2117 34.1005 36.1293 34.2528 36.1293H37.9379C39.1178 36.1293 40.0764 35.2029 40.0764 34.0647V22.8732C40.0764 21.7321 39.1168 20.8047 37.9379 20.8047H26.3457C25.1637 20.8047 24.2031 21.7331 24.2031 22.8732V34.0647C24.2031 35.2039 25.1647 36.1293 26.3457 36.1293H30.0307L30.0307 36.1303ZM30.5273 28.4701C29.8733 27.9956 29.4489 27.2427 29.4489 26.3938C29.4489 24.9605 30.6572 23.794 32.1417 23.794C33.6263 23.794 34.8345 24.9606 34.8345 26.3938C34.8345 27.2427 34.4091 27.9947 33.7562 28.4701C35.5758 29.0613 36.9314 30.6249 37.1264 32.5659C37.1487 32.7815 36.9842 32.9737 36.7619 32.9943C36.7487 32.9952 36.7355 32.9962 36.7223 32.9962C36.5151 32.9962 36.3384 32.8453 36.3181 32.6423C36.109 30.564 34.3137 28.9965 32.1428 28.9965C29.9718 28.9965 28.1765 30.5641 27.9675 32.6423C27.9452 32.858 27.7482 33.0168 27.5238 32.9942C27.3004 32.9737 27.1369 32.7815 27.1592 32.5658C27.3552 30.6248 28.7098 29.0621 30.5295 28.4701L30.5273 28.4701Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M32.1462 28.2112C33.183 28.2112 34.0268 27.3966 34.0268 26.3957C34.0268 25.3947 33.183 24.5801 32.1462 24.5801C31.1094 24.5801 30.2656 25.3947 30.2656 26.3957C30.2656 27.3966 31.1094 28.2112 32.1462 28.2112Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman == "de" ? "Impressum" : "Imprint"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to="/delete-user-account" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M23.9899 26.2872C23.2823 26.2872 22.6148 26.2897 21.9465 26.2856C21.7934 26.2848 21.6345 26.2831 21.4879 26.2438C20.9563 26.0997 20.6419 25.6066 20.7041 25.0423C20.7606 24.5313 21.2004 24.1292 21.7344 24.1029C21.8204 24.0989 21.9056 24.0997 21.9916 24.0997C28.4518 24.0997 34.9129 24.0989 41.3731 24.1021C41.5509 24.1021 41.7376 24.1087 41.9055 24.1595C42.4239 24.3183 42.7171 24.813 42.6442 25.365C42.5779 25.8646 42.143 26.2684 41.6197 26.2807C40.9849 26.2954 40.3502 26.2864 39.7147 26.2872C39.6123 26.2872 39.5099 26.2872 39.36 26.2872C39.36 26.4092 39.36 26.5165 39.36 26.623C39.36 30.8695 39.3584 35.1152 39.3609 39.3617C39.3617 40.6868 38.7941 41.6852 37.6557 42.3551C37.1332 42.6631 36.5566 42.7671 35.9522 42.7655C33.7212 42.7597 31.4903 42.763 29.2602 42.763C28.6336 42.763 28.0071 42.7646 27.3814 42.763C25.4068 42.7564 23.9916 41.3461 23.9899 39.3732C23.9866 35.1357 23.9891 30.8982 23.9891 26.6599C23.9899 26.5493 23.9899 26.4387 23.9899 26.2872ZM30.5812 33.4412C30.5812 32.849 30.5837 32.2577 30.5804 31.6656C30.5779 31.2798 30.5968 30.8908 30.5509 30.51C30.4829 29.9506 29.9735 29.5534 29.4313 29.5853C28.8507 29.6197 28.3871 30.0734 28.3847 30.6533C28.3765 32.5059 28.3789 34.3584 28.3838 36.211C28.3847 36.546 28.5313 36.8269 28.7974 37.0316C29.1553 37.3077 29.5501 37.3568 29.9571 37.1586C30.3855 36.9497 30.5787 36.5837 30.5804 36.116C30.5837 35.2249 30.5804 34.3331 30.5812 33.4412ZM34.971 33.4567C34.971 32.5558 34.9833 31.6549 34.962 30.7549C34.9563 30.5264 34.8875 30.2757 34.7737 30.0775C34.5345 29.6631 34.0243 29.4977 33.5615 29.6295C33.0873 29.7655 32.772 30.1938 32.7712 30.7401C32.7671 32.5329 32.7679 34.3257 32.7728 36.1176C32.7728 36.261 32.7982 36.41 32.8449 36.5452C33.0128 37.0366 33.519 37.3388 34.0185 37.2601C34.5746 37.1733 34.9628 36.7442 34.9678 36.1823C34.9759 35.2757 34.9702 34.3658 34.971 33.4567Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M31.6631 22.9891C30.917 22.9891 30.1717 22.9998 29.4256 22.9858C28.8851 22.976 28.4494 22.5575 28.3855 22.0276C28.3216 21.5002 28.6541 20.9973 29.1709 20.8474C29.252 20.8237 29.3388 20.8098 29.4231 20.8089C30.9235 20.8065 32.4231 20.7999 33.9235 20.8106C34.4641 20.8147 34.899 21.2365 34.9637 21.768C35.0284 22.2946 34.6967 22.8016 34.1774 22.9457C34.0398 22.9842 33.89 22.9883 33.7458 22.9899C33.0513 22.994 32.3568 22.9916 31.6631 22.9916C31.6631 22.9916 31.6631 22.9899 31.6631 22.9891Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>
                      {ingerman == "de" ? "Konto löschen" : "Delete Account"}
                    </h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>

              <li
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/logout-page")}
              >
                <div className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M34.5821 20.8047C37.3931 20.8047 39.6857 22.9898 39.6857 25.68V30.9396H32.7734C32.278 30.9396 31.8863 31.3129 31.8863 31.7851C31.8863 32.2463 32.278 32.6306 32.7734 32.6306H39.6857V37.8792C39.6857 40.5694 37.3931 42.7655 34.5591 42.7655H28.9486C26.1261 42.7655 23.8335 40.5804 23.8335 37.8902V25.691C23.8335 22.9898 26.1376 20.8047 28.9601 20.8047H34.5821ZM42.562 27.9971C42.9016 27.6567 43.4565 27.6567 43.7962 27.9861L47.1025 31.1814C47.2723 31.3461 47.3629 31.5547 47.3629 31.7853C47.3629 32.0049 47.2723 32.2245 47.1025 32.3782L43.7962 35.5735C43.6263 35.7382 43.3999 35.8261 43.1847 35.8261C42.9583 35.8261 42.7318 35.7382 42.562 35.5735C42.2223 35.2441 42.2223 34.7061 42.562 34.3767L44.3736 32.6308H39.6859V30.9398H44.3736L42.562 29.1939C42.2223 28.8645 42.2223 28.3265 42.562 27.9971Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman == "de" ? "Ausloggen" : "Log out"}</h3>
                  </div>
                  <Link to="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="16"
                      viewBox="0 0 11 16"
                      fill="none"
                    >
                      <path
                        d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                        fill="#585858"
                      />
                    </svg>
                  </Link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </LayoutCoach>
  );
}
